<template>
  <div v-loading="initLoading">
<div style="padding: 20px;position:relative">
  <div class="ReportDetailPage" style="width: 500px;background-color: #fafafa">
    <div style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }" >数据中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/ChannelFlowDetails' }" >基础账户明细</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="font-size: 25px;margin-top: 10px;">
      <p>基础账户明细</p>
    </div>
    <template>
      <div v-show="invoiceBank.jb_wallet" class="el-card box-card" style="right: 7.5%">
        <div class="el-card__header cus-header">
          <slot name="header">充值及服务费打款至以下账户</slot>
        </div>
        <div class="el-card__body" style="padding: 0 10px">
          <div class="text">
            <span>{{invoiceBank.jb_wallet}}</span>
          </div>
        </div>
      </div>
    </template>
    <div style="width: 500px; font-family: 宋体; font-size: 25px;font-weight: bold">
      <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" style=" margin-top: 10px;width: 300px" >
        <el-form-item label="时间选择" prop="value1" style="width: 700px">
          <el-date-picker
            v-model="ruleForm2.startDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="开始日期"
            :picker-options="pickerOptions0">
          </el-date-picker>
          <el-date-picker
            v-model="ruleForm2.endDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="结束日期"
            :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="供应商" prop="selectedSupplierIds">
          <el-select  v-model="ruleForm2.selectedSupplierIds" value-key="id" multiple placeholder="请选择" @change="supplierid()"  style="width: 400px">
            <el-option
              v-for="(item) in user"
              :key="item.id"
              :label="item.name"
              :value='item'>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="margin-left: 10vw">
        <el-button style="color: white; variant:'outlined';border-color: #FF6633; background-color: #FF6633;margin-bottom: 10px"   :loading="loading" @click="Channel()">确定</el-button>
        <el-button style="color: white; variant:'outlined';border-color: #FF6633; background-color: #FF6633;margin-bottom: 10px"   :disabled="tableData.length==0" @click="exportExcel">导出excel</el-button>
      </div>
    </div>
  </div>
  <div>
    <el-row :gutter="20">
      <el-col :span="18"><div class="grid-content bg-purple">
        <el-table
         id="table"
        :data="tableData"
        height="400"
        border
        :summary-method="getSummaries"
        show-summary
        style="width: 100%">
        <el-table-column
          prop="name"
          align="center"
          label="供应商名称">
        </el-table-column>
        <el-table-column
          prop="type"
          label="加减"
          align="center"
          width="80">
        </el-table-column>
        <el-table-column
          prop="project"
          label="项目描述"
          align="center"
          :formatter="projectFormatter"
          width="150">
        </el-table-column>
        <el-table-column
          prop="bonus"
          label="金额"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          prop="surplusBonus"
          label="余额"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          prop="dateId"
          label="日期"
          align="center"
          width="150">
        </el-table-column>
      </el-table></div></el-col>
      <el-col :span="6"><div class="grid-content bg-purple-light">
        <el-table
          id="table1"
          :data="collectTable"
          border
          :cell-style="{padding:'0px'}"
          height="400"
          style="width: 100%;">
          <el-table-column :label="tableTitle" align="center">
            <el-table-column
              prop="project"
              label="项目描述"
              align="center"
              :formatter="projectFormatter"
              min-width="75%">
            </el-table-column>
            <el-table-column
              prop="bonus"
              align="center"
              label="总金额">
            </el-table-column>
          </el-table-column>
        </el-table>
      </div></el-col>
    </el-row>
  </div>
  </div>
  </div>
</template>

<script>
import {getFinanceSupplierByUserId} from "@/api/ServiceCharge"
import { Channel } from '@/api/ChannelFlowDetails'
import XLSX from "xlsx"
import FileSaver from "file-saver"

export default {
  data () {
    return {
      // 判断时间的限制
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.ruleForm2.endDate) {
            return time.getTime() > new Date(this.ruleForm2.endDate).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if (this.ruleForm2.startDate) {
            return (time.getTime() < new Date(this.ruleForm2.startDate).getTime() || time.getTime() > Date.now())
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      ruleForm2: { selectedSupplierIds: [], endDate: this.getNowTime(), startDate: this.getStartTime() },
      // 判断供应商是否选择
      rules2: {
        selectedSupplierIds: [
          { required: true, message: '请至少选择一个供应商', trigger: 'change' }
        ]
      },
      user: [],
      value: '',
      token: '',
      selectedSupplierId: [],
      tableData: [],
      current: 0, // 期初余额
      residues: {},
      loading : false,
      endDate: '',
      startDate: '',
      collectTable:[],
      tableTitle: '本期总计',
      excelName: '',
      invoiceBank: {},   // 收款账户
      initLoading:true
    }
  },
  created () {
    // 进入测页面以后 查询出下拉框的所有值
    this.allUser()
  },
  methods: {
    Channel () {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm2.selectedSupplierIds != '') {
        this.loading =true
        this.startDate = this.ruleForm2.startDate
        this.endDate = this.ruleForm2.endDate
        let from = JSON.parse(JSON.stringify(this.ruleForm2))
        from.selectedSupplierIds = from.selectedSupplierIds.map(sup => sup.id)
        Channel(this.token, from).then(res => {
          if (res.data.code === 200) {
            if (res.data!=null && res.data.date.reinforceChannel.channels !== null) {
              this.tableData = res.data.date.reinforceChannel.channels
              this.invoiceBank = res.data.date.invoiceBank
              this.current = res.data.date.reinforceChannel.current
              this.collectTable = res.data.date.reinforceChannel.channels2
              this.tableTitle = '本期总计('+this.startDate+' / '+this.endDate+')'
              this.excelName = this.ruleForm2.selectedSupplierIds[0].name+'_'+this.startDate+'至'+this.endDate
            }else{
              this.loading =false
              this.$notify.info({
                title: '提示',
                message: '没有查询到数据，请修改查询时间',
                position: 'bottom-right'
              })
            }
          }else{
            this.$notify.error({
              title: '提示',
              message: res.data.msg,
              position: 'bottom-right'
            })
          }
        }).catch(error => {
          let status = error.response.status;
          if (status == 500){
            this.$notify.error({
              title: '错误',
              message: '查询失败，请联系管理员',
              position: 'bottom-right'
            })
          }
          this.loading =false
        }).finally(() => {
          this.loading =false
        })
      } else {
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
      }
    },
    exportExcel() {
      let time = new Date()
      let year = time.getFullYear()
      let month = time.getMonth() + 1
      let day = time.getDate()
      let name ='基础账户明细_'+this.excelName
      //  #table要导出的是哪一个表格
      let  worBook =XLSX.utils.book_new()
      let sheet1=XLSX.utils.table_to_sheet(document.querySelector("#table"))
      let sheet2=XLSX.utils.table_to_sheet(document.querySelector("#table1"))
      sheet1["!fullref"] ="A1:K"+this.tableData.length+1
      sheet1["!ref"] ="A1:K"+this.tableData.length+1
      for(let i=1;i<12;i++){
        sheet1["I"+i]=sheet2["A"+i]
        sheet1["J"+i]=sheet2["B"+i]
      }
      //合并第一行数据[I1,J1]
      sheet1["!merges"] = [{
        s: {//s为开始
          c: 8,//开始列
          r: 0//开始取值范围
        },e: {//e结束
          c: 9,//结束列
          r: 0//结束范围
        }
      }]
      sheet1['!cols'] = [ {wpx: 200},{ wpx:50},{ wpx:80},{ wpx:80},{ wpx:80},
        { wpx:80},{ wpx:40},{ wpx:40},{ wpx:100},{ wpx:100}]
      XLSX.utils.book_append_sheet(worBook,sheet1,"流水明细")
      let wbout = XLSX.write(worBook, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      })
      let tmpDown = new Blob([wbout], {
        type: "application/octet-stream"
      });
      try {
        FileSaver.saveAs(
          tmpDown,
          name + ".xlsx"
        )
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout)
      }
      return wbout
    },
    getSummaries (param) {
      const { columns } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '期初余额'
          return
        }
        if (index === 4) {
          sums[index] = this.current
        }
      })
      return sums
    },
    allUser () {
      this.token = localStorage.getItem('token')
      getFinanceSupplierByUserId(this.token).then(res => {
        if (res.data != null) {
          this.user = res.data
          if (this.user.length == 1){
            this.ruleForm2.selectedSupplierIds = this.user
          }
        }
        this.initLoading = false
      })
    },
    // 处理默认选中当前日期
    getNowTime () {
      let now = new Date()
      let year = now.getFullYear() // 得到年份
      let month = now.getMonth() // 得到月份
      let date = now.getDate() // 得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      let defaultDate = `${year}-${month}-${date}`
      return defaultDate
      // this.$set(this.ruleForm2, 'endDate', defaultDate)
    },
    getStartTime(){
      let now = new Date()
      now = new Date(now.getTime() + 24*3600*1000)
      now.setMonth(now.getMonth()-1);
      let year = now.getFullYear() // 得到年份
      let month = now.getMonth() // 得到月份
      let date = now.getDate() // 得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      let defaultDate = `${year}-${month}-${date}`
      return defaultDate
    },
    supplierid () {
      // 根据选择的供应商赋值给品牌和区域
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm2.selectedSupplierIds != '') {
        if (this.ruleForm2.selectedSupplierIds.length > 1) {
          this.ruleForm2.selectedSupplierIds.splice(1, 1)
          this.$notify({
            title: '警告',
            message: '只能选择一个供应商',
            type: 'warning',
            position: 'bottom-right'
          })
        }
      }
    },
    projectFormatter(row,c){
      switch (row.project){
        case -1: return "期初余额"
        case 1: return "结算"
        case 2: return "特发"
        case 3: return "补发"
        case 4: return "服务费"
        case 5: return "特发撤回"
        case 6: return "撤回"
        case 7: return "充值"
        case 8: return "全部"
        case 9: return "系统奖励"
        case 10: return "注册"
        case 11: return "账户余额退回"
        case 12: return "其余"
        case 15: return "通路活动奖励金"
        case 17: return "灵工支出"
        case 18: return "灵工服务费"
        case 999: return "余额"
        default: return "不知道"
      }
    }
  }
}
</script>

<style scoped>
  .el-table{
    overflow:visible !important
  }
  /*.el-table td, .el-table th{*/
  /*  padding: 0px !important;*/
  /*}*/
  .text {
    font-size: 14px;
    white-space: pre-line;
    text-align: left;
    line-height: 25px;
  }
  .box-card {
    z-index: 3 !important;
    /*width: 360px;*/
    position: absolute;
    right: 325px;
    top: 14%;
    box-shadow:1px 1px 10px #cccccc;
  }
  .cus-header {
    padding: 10px 10px !important;
    background-color: #ef6c00;
    color: white;
  }
</style>
